import { render, staticRenderFns } from "./ticketChatMeDetailInfo.vue?vue&type=template&id=415fbd33&scoped=true&"
import script from "./ticketChatMeDetailInfo.vue?vue&type=script&lang=js&"
export * from "./ticketChatMeDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./ticketChatMeDetailInfo.vue?vue&type=style&index=0&id=415fbd33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415fbd33",
  null
  
)

export default component.exports